import React, { useMemo } from 'react';
import { Card, FlexRow, Grid, NavigationItem } from '../../../ui-toolkit';
import { Form, Formik } from 'formik';
import { TextFieldTW } from '../../../tailwindComponents/textInputTW/TextFieldTW';
import { SelectFieldTW } from '../../../tailwindComponents/selectTW/SelectFieldTW';
import { generateCreateTagScheme } from '../../../validation/administration/CreateTagValidator';
import { eTagType } from '../../../types/tags/eTagType';
import { ICreateTagRequest } from '../../../types/tags/ICreateTagRequest';
import { checkForMutationSuccess } from '../../../API/checkForMutationSuccess';
import { useCreateTagMutation, useListTagsQuery } from '../../../API/tags/TagApi';
import { ClientUrlFactory } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { useHistory } from 'react-router-dom';
import { ButtonTW } from '../../../tailwindComponents/buttonTW/ButtonTW';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { upperFirst } from 'lodash';

export const CreateTagPage: React.FC = () => {
  const history = useHistory();
  const typeOptions: SelectOption[] = useMemo(
    () => Object.values(eTagType).map((t) => ({ label: upperFirst(t.toString()), value: t })),
    []
  );
  const [createTag, { error, isLoading }] = useCreateTagMutation();
  const { data: allTags = [] } = useListTagsQuery();

  const onCreate = async (request: ICreateTagRequest) => {
    const result = await createTag(request);
    if (checkForMutationSuccess(result, `Tag Created`, 'Error Creating Tag')) {
      history.push(ClientUrlFactory().urlFor.administrationListTags());
    }
  };

  const createTagScheme = useMemo(() => generateCreateTagScheme(allTags), [allTags]);

  return (
    <>
      <ErrorMessageTW rtkError={error} />
      <Grid width={'440px'} data-test-id={'create-tag-page'}>
        <Card title={'Add a New Tag'}>
          <Formik
            initialValues={{ id: '', label: '', type: eTagType.NORMAL }}
            onSubmit={onCreate}
            validationSchema={createTagScheme}
          >
            {({ isValid, dirty }) => (
              <Form>
                <TextFieldTW name={'label'} labelText={'Name'} data-test-id={'tag-label'} isRequired />
                <SelectFieldTW
                  name={'type'}
                  options={typeOptions}
                  labelText={'Type'}
                  data-test-id={'tag-type'}
                  isRequired
                />
                <FlexRow justifyContent={'start'} width={100} className={'mt-4'}>
                  <ButtonTW type={'submit'} disabled={isLoading || !isValid || !dirty} data-test-id={'tag-create'}>
                    Create
                  </ButtonTW>
                  <NavigationItem to={ClientUrlFactory().urlFor.administrationListTags()} text={'Cancel'}>
                    <ButtonTW data-test-id={'tag-cancel'} secondary>
                      Cancel
                    </ButtonTW>
                  </NavigationItem>
                </FlexRow>
              </Form>
            )}
          </Formik>
        </Card>
      </Grid>
    </>
  );
};
